import React from 'react';
import { useSelector } from 'react-redux';
import { getWordCount, getCharCount } from 'rubriq/helpers/richTextWordCount';
import { T } from 'shared/helper/translate';
var getGlobalWordCount = function getGlobalWordCount(userTemplateResponses) {
  return Object.values(userTemplateResponses).reduce(function (prev, curr) {
    return prev + getWordCount(curr);
  }, 0);
};
var getGlobalCharCount = function getGlobalCharCount(userTemplateResponses) {
  return Object.values(userTemplateResponses).reduce(function (prev, curr) {
    return prev + getCharCount(curr);
  }, 0);
};
var RubriqGlobalWordCount = function RubriqGlobalWordCount() {
  var _criteriaResponses$te;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    _useSelector$curie$ab = _useSelector.curie.abstractWriter,
    criteriaResponses = _useSelector$curie$ab.criteriaResponses,
    templateResponses = _useSelector$curie$ab.templateResponses;
  var _ref = (_criteriaResponses$te = criteriaResponses['text-limit']) !== null && _criteriaResponses$te !== void 0 ? _criteriaResponses$te : {
      useCharacters: false,
      maxLength: 0
    },
    useCharacters = _ref.useCharacters,
    maxLength = _ref.maxLength;
  var globalCount = useCharacters ? getGlobalCharCount(templateResponses) : getGlobalWordCount(templateResponses);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-3 rounded-2 bg-light"
  }, /*#__PURE__*/React.createElement("p", {
    className: "p-0 m-0 fw-semibold"
  }, useCharacters ? /*#__PURE__*/React.createElement(T, {
    source: "curie.total-abstract-character-count"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "curie.total-abstract-word-count"
  })), /*#__PURE__*/React.createElement("p", {
    className: "p-0 m-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: globalCount <= maxLength ? 'curie-abstract-template-word-count-within-limit fw-semibold' : 'curie-abstract-template-word-count-outside-limit fw-semibold'
  }, globalCount), " of ".concat(maxLength)));
};
export default RubriqGlobalWordCount;